const data = [
    {
        "pan_required" : "PAN is required",
        "pan_pattern" : "Invalid PAN",
        "dob_required" : "Date of Birth is required",
        "dob_range" : "The Investor should be greater than 18 years.",
        "mob_required" : "Mobile Number is required",
        "mob_pattern" : "Invalid Mobile Number",
        "email_required" : "Email ID is required",
        "email_pattern" : "Invalid Email ID",
        "reffcode_maxlength" : "Referral Code cannot exceed 20 Characters",
        "reffcode_pattern" : "Referral Code can only be Alpha numeric.",
        "leadcity_required" : "Nearest City is required",
        "leadstate_required" : "State is required",
        "default_required" : "This field is required.",
        "occupation_invalid" : "Invalid Occupation.",
        "education_required" : "Educational Qualification is required",
        "annualInc_required" : "Annual Income is required",
        "annualInc_invalid" : "Invalid Annual Income",
        "plRelation_required" : "Political relation is required",
        "fullname_required" : "Full Name is required",
        "fullname_invalid" : "Invalid Full Name",
        "name_minlength" : "Name should contain atleast 2 Characters",
        "fathername_required" : "Father Name is required",
        "fathername_invalid" : "Invalid Father Name",
        "mothername_required" : "Mother Name is required",
        "mothername_invalid" : "Invalid Mother Name",
        "address_invalid" : "Invalid Address",
        "city_invalid" : "Invalid City",
        "state_invalid" : "Invalid State",
        "zipcode_required" : "Zip Code is Required.",
        "zipcode_invalid" : "Invalid Zip Code",
        "birthCountry_required" : "Birth Country is required.",
        "country_invalid" : "Invalid Country.",
        "taxCountry_required" : "Tax Country is required.",
        "cheque_required" : "Please Upload Cancelled Cheque.",
        "default_fileType" : "Please upload file having extensions jpeg, jpg, and png only.",
        "default_fileType_incomeproof" : "Please upload file having extensions jpeg, jpg, png and pdf only.",
        "default_fileSize" : "Maximum Allowed File size is 10MB.",
        "accNo_required" : "Account Number is required.",
        "accNo_pattern" : "Account Number can only be numeric between 8-18 digits",
        "accNo_notmatch" : "Account Number not matching",
        "ifsc_required" : "IFSC is required.",
        "ifsc_invalid" : "Invalid IFSC.",
        "bankname_required" : "Bank Name is required.",
        "bankbranchname_required" : "Bank Branch is required.",
        "branchAdd_required" : "Branch Address is required.",
        "accType_required" : "Account Type is Required.",
        "panFile_required" : "Please Upload PAN Card File.",
        "photoFile_required" : "Please Click/Upload Valid Photo.",
        "ipvFile_required" : "Please Click/Upload Valid IPV File.",
        "default_fileType2" : "Please upload file having extensions jpeg, jpg and png only.",
        "signFile_required" : "Please Click/Upload Valid Signature.",
        "addproof_required" : "Please Select Address Proof Type",
        "validAddProof_required" : "Please Click/Upload Valid Address Proof.",
        "overseasAddProof_required" : "Please Click/Upload Valid Overseas Address Proof.",
        "passportFile_required" : "Please Click/Upload Valid Passport File.",
        "uploadVisa_required" : "Please Upload VISA.",
        "incProof_required" : "Please Select Income Proof Type",
        "incProofFile_required" : "Please Upload Valid Income Proof File.",
        "aofFile_required" : "Please Click/Upload Valid AOF File.",
        "pan_pattern2" : "Please enter a valid <b>individual</b> PAN",
        "invalidFormat" : "Invalid format",
        "userid_required" : "User ID is required",
        "username_pattern" : "User ID can only be Alpha numeric.",
        "username_maxlength" : "User ID cannot exceed 10 Characters",
        "username_minlength" : "User ID Should Contain Atleast 6 Characters",
        "userid_exists" : "User ID is already taken",
        "email_invalid" : "Invalid Email ID",
        "password_required" : "Password is required",
        "move_forward" : "Cannot move Forward.",
        "otp_required" : "OTP is required Field.",
        "otp_pattern" : "OTP must be of exactly 4 digits",
        'unifiedotp_pattern' : "OTP must be of exactly 6 digits",
        "reffCode_invalid" : "Invalid Referral Code.",
        "nominee_required" : "Nominee Name is required",
        "nominee_same" : "You cannot enter your name in Nominee Name",
        "duplicte_nomineeName":"Nominee name is already entered",
        "name_invalid" : "Invalid Name",
        "nomineeRelation_required" : "Nominee relation is required",
        "sharePrcnt_required" : "Share Percent is Required.",
        "sharePrcnt_invalid" : "Invalid Share Percent",
        "doctype_required" : "Document Type is Required",
        "docID_required" : "Document Id is Required",
        "docID_invalid" : "Invalid Document ID",
        "duplicte_docId" : "Document ID is already entered",
        "defaultUpload_valid" : "Please Upload Valid File.",
        "guardianname_required" : "Guardian Name is required.",
        "guardianname_invalid" : "Invalid Guardian Name",
        "guardianAdd_invalid" : "Invalid Guardian Address",
        "defaultRelation_required" : "Relation is Required",
        "nse": "NSE CASH",
        "bsecash" : "BSE CASH",
        "NSEfno" : "NSE F&O",
        "bsefno" : "BSE F&O",
        "nsecurrency" : "NSE CURRENCY",
        "bsecurrency" : "BSE CURRENCY",
        "mcx" : "MCX",
        "ncdex" : "NCDEX",
        "brokerage_min" : "Min value allowed is 1.",
        "eqt_min" : "Min value allowed is 0.01%.",
        "defaultName_required" : "Name is required",
        "defaultSubject_required" : "Subject is required",
        "defaultInvalid_msg" : "Invalid Message",
        "clientId_required" : "Client ID is required",
        "clientId_pattern" : "Client ID can only be Alpha numeric.",
        "clientID_maxlength" : "Client ID cannot exceed 20 Characters",
        "purpose_required" : "Purpose is Required.",
        "signUpload2" : "Please Upload Valid Signature.",
        "chequeUpload2" : "Please Upload Valid Cancelled Cheque or Bank Statement File.",
        "okaybtn" : "OKAY",
        "proceedbtn" : "PROCEED",
        "cancelbtn" : "CANCEL",
        "attentionlbl" : "Attention!!",
        "yeslbl" : "Yes",
        "nolbl" : "No",
        "importDatalbl" : "Import Data?",
        "startnewonelbl" : "No, Start a new One",
        "yesimportlbl" : "Yes, Import Data",
        "onbstatuslbl" : "Onboarding Status",
        "exitlbl" : "Exit",
        "continuelbl" : "Continue",
        "errorlbl" : "Error",
        "attentionlbl2" : "Attention",
        "alertlbl" : "Alert",
        "noAadharConsent" : "If you proceed with Manual Verification, Driving license, Voter ID and Passport will be taken as address proof. If you have Aadhaar as address proof, <b>Go back to Digilocker</b>",
        "gotodigilocker" : "Go Back to Digilocker",
        "manualflowproceed" : "Proceed with Manual Verification",
        "identify_Number" : "Identify Number is required",
        "expire_date"  : "Expire Date Required",
        "default_fileSize2" : "Maximum Allowed File size is 10MB.",
        "default_fileSize3" : "Maximum Allowed File size is 5MB.",
    },
    {
        "pan_required" : "पैन आवश्यक है",
        "pan_pattern" : "अमान्य पैन",
        "dob_required" : "जन्म तिथि आवश्यक है",
        "dob_range" : "निवेशक की आयु 18 वर्ष से अधिक होनी चाहिए।",
        "mob_required" : "मोबाइल नंबर चाहिए",
        "mob_pattern" : "अमान्य मोबाइल नंबर",
        "email_required" : "ईमेल आईडी आवश्यक है",
        "email_pattern" : "अमान्य ईमेल आईडी",
        "reffcode_maxlength" : "रेफ़रल कोड 20 वर्णों से अधिक नहीं हो सकता",
        "reffcode_pattern" : "रेफरल कोड केवल अल्फा न्यूमेरिक हो सकता है।",
        "leadcity_required" : "निकटतम शहर आवश्यक है",
        "leadstate_required" : "राज्य की आवश्यकता है",
        "default_required" : "यह फ़ील्ड आवश्यक है.",
        "occupation_invalid" : "अमान्य पेशा.",
        "education_required" : "शैक्षिक योग्यता आवश्यक है",
        "annualInc_required" : "वार्षिक आय आवश्यक है",
        "annualInc_invalid" : "अमान्य वार्षिक आय",
        "plRelation_required" : "राजनीतिक संबंध की आवश्यकता है",
        "fullname_required" : "पूरा नाम आवश्यक है",
        "fullname_invalid" : "अमान्य पूरा नाम",
        "name_minlength" : "नाम में कम से कम 2 अक्षर होने चाहिए",
        "fathername_required" : "पिता का नाम आवश्यक है",
        "fathername_invalid" : "अमान्य पिता का नाम",
        "mothername_required" : "माता का नाम आवश्यक है",
        "mothername_invalid" : "अमान्य माता का नाम",
        "address_invalid" : "गलत पता",
        "city_invalid" : "अमान्य शहर",
        "state_invalid" : "अमान्य स्थिति",
        "zipcode_required" : "ज़िप कोड आवश्यक है।",
        "zipcode_invalid" : "अमान्य ज़िप कोड",
        "birthCountry_required" : "जन्म देश आवश्यक है।",
        "country_invalid" : "अमान्य देश.",
        "taxCountry_required" : "कर देश आवश्यक है।",
        "cheque_required" : "कृपया रद्द किया गया चेक या बैंक विवरण फ़ाइल अपलोड करें।",
        "default_fileType" : "कृपया केवल jpeg, jpg, और png एक्सटेंशन वाली फाइल अपलोड करें।",
        "default_fileType_incomeproof" : "कृपया केवल jpeg, jpg, png और pdf एक्सटेंशन वाली फाइल अपलोड करें।",
        "default_fileSize" : "अधिकतम अनुमत फ़ाइल का आकार 10MB है।",
        "accNo_required" : "खाता संख्या आवश्यक है।",
        "accNo_pattern" : "खाता संख्या केवल 8-18 अंकों के बीच संख्यात्मक हो सकती है",
        "accNo_notmatch" : "खाता संख्या मेल नहीं खा रही है",
        "ifsc_required" : "आईएफएससी की आवश्यकता है।",
        "ifsc_invalid" : "अमान्य IFSC.",
        "bankname_required" : "बैंक का नाम आवश्यक है.",
        "bankbranchname_required" : "बैंक शाखा की आवश्यकता है।",
        "branchAdd_required" : "शाखा का पता आवश्यक है.",
        "accType_required" : "खाता प्रकार आवश्यक है।",
        "panFile_required" : "कृपया पैन कार्ड फ़ाइल अपलोड करें।",
        "photoFile_required" : "कृपया वैध फोटो क्लिक/अपलोड करें।",
        "ipvFile_required" : "कृपया वैध आईपीवी फ़ाइल पर क्लिक/अपलोड करें।",
        "default_fileType2" : "कृपया केवल jpeg, jpg और png एक्सटेंशन वाली फ़ाइल अपलोड करें।",
        "signFile_required" : "कृपया वैध हस्ताक्षर पर क्लिक/अपलोड करें।",
        "addproof_required" : "कृपया पता प्रमाण प्रकार चुनें",
        "validAddProof_required" : "कृपया वैध पता प्रमाण पर क्लिक/अपलोड करें।",
        "overseasAddProof_required" : "कृपया वैध विदेशी पते के प्रमाण पर क्लिक/अपलोड करें।",
        "passportFile_required" : "कृपया वैध पासपोर्ट फ़ाइल पर क्लिक/अपलोड करें",
        "uploadVisa_required" : "कृपया वीज़ा अपलोड करें।",
        "incProof_required" : "कृपया आय प्रमाण प्रकार का चयन करें",
        "incProofFile_required" : "कृपया वैध आय प्रमाण फ़ाइल अपलोड करें।",
        "aofFile_required" : "कृपया मान्य AOF फ़ाइल पर क्लिक/अपलोड करें।",
        "pan_pattern2" : "कृपया एक मान्य <b>व्यक्तिगत</b> पैन दर्ज करें",
        "invalidFormat" : "अवैध प्रारूप",
        "userid_required" : "यूजर आईडी आवश्यक है",
        "username_pattern" : "यूजर आईडी केवल अल्फा न्यूमेरिक हो सकती है।",
        "username_maxlength" : "उपयोगकर्ता आईडी 10 वर्णों से अधिक नहीं हो सकती",
        "username_minlength" : "यूजर आईडी में कम से कम 6 अक्षर होने चाहिए",
        "userid_exists" : "यूजर आईडी पहले ही ली जा चुकी है",
        "email_invalid" : "अमान्य ईमेल आईडी",
        "password_required" : "पासवर्ड की आवश्यकता है",
        "move_forward" : "आगे नहीं बढ़ सकता।",
        "otp_required" : "ओटीपी आवश्यक है फील्ड।",
        "otp_pattern" : "ओटीपी बिल्कुल 4 अंकों का होना चाहिए",
        "reffCode_invalid" : "अमान्य रेफरल कोड।",
        "nominee_required" : "नामांकित व्यक्ति का नाम आवश्यक है",
        "nominee_same" : "आप नॉमिनी नेम में अपना नाम दर्ज नहीं कर सकते",
        "duplicte_nomineeName":"नामांकित व्यक्ति का नाम पहले ही दर्ज किया जा चुका है",
        "name_invalid" : "अमान्य नाम",
        "nomineeRelation_required" : "नॉमिनी संबंध आवश्यक है",
        "sharePrcnt_required" : "शेयर प्रतिशत आवश्यक है।",
        "sharePrcnt_invalid" : "Invalid Share Percent",
        "doctype_required" : "दस्तावेज़ प्रकार आवश्यक है",
        "docID_required" : "दस्तावेज़ आईडी आवश्यक है",
        "docID_invalid" : "अमान्य दस्तावेज़ आईडी",
        "duplicte_docId" : "दस्तावेज़ आईडी पहले से मौजूद है",
        "defaultUpload_valid" : "कृपया वैध फ़ाइल अपलोड करें।",
        "guardianname_required" : "अभिभावक का नाम आवश्यक है।",
        "guardianname_invalid" : "अमान्य अभिभावक का नाम",
        "guardianAdd_invalid" : "अमान्य अभिभावक का पता",
        "defaultRelation_required" : "रिश्ता जरूरी है",
        "nse": "एनएसई कैश",
        "bsecash" : "बीएसई नकद",
        "NSEfno" : "एनएसई एफ एंड ओ",
        "bsefno" : "बीएसई एफ एंड ओ",
        "nsecurrency" : "एनएसई मुद्रा",
        "bsecurrency" : "बीएसई मुद्रा",
        "mcx" : "एमसीएक्स",
        "ncdex" : "हालांकि एनसीडीईएक्स",
        "brokerage_min" : "न्यूनतम मान की अनुमति 1 है।",
        "eqt_min" : "न्यूनतम मान की अनुमति 0.01% है।",
        "defaultName_required" : "नाम आवश्यक है",
        "defaultSubject_required" : "विषय आवश्यक है",
        "defaultInvalid_msg" : "अमान्य संदेश",
        "clientId_required" : "क्लाइंट आईडी आवश्यक है",
        "clientId_pattern" : "क्लाइंट आईडी केवल अल्फा न्यूमेरिक हो सकती है।",
        "clientID_maxlength" : "क्लाइंट आईडी 20 वर्णों से अधिक नहीं हो सकती",
        "purpose_required" : "उद्देश्य की आवश्यकता है।",
        "signUpload2" : "कृपया वैध हस्ताक्षर अपलोड करें।",
        "chequeUpload2" : "कृपया वैध रद्द चेक या बैंक स्टेटमेंट फाइल अपलोड करें।",
        "okaybtn" : "ओके",
        "proceedbtn" : "आगे बढ़ना",
        "cancelbtn" : "रद्द करना",
        "attentionlbl" : "ध्यान दें !!",
        "yeslbl" : "हां",
        "nolbl" : "नहीं",
        "importDatalbl" : "आयात आंकड़ा?",
        "startnewonelbl" : "नहीं, एक नई शुरुआत करें",
        "yesimportlbl" : "हाँ, डेटा आयात करें",
        "onbstatuslbl" : "ऑनबोर्डिंग स्थिति",
        "exitlbl" : "एग्जिट",
        "continuelbl" : "जारी रखना",
        "errorlbl" : "गलती",
        "attentionlbl2" : "ध्यान दें",
        "alertlbl" : "चेतावनी",
        "noAadharConsent" : "यदि आप मैन्युअल सत्यापन के साथ आगे बढ़ते हैं, तो ड्राइविंग लाइसेंस, मतदाता पहचान पत्र और पासपोर्ट को पते के प्रमाण के रूप में लिया जाएगा। अगर आपके पास एड्रेस प्रूफ के तौर पर आधार है तो <b> गो बैक टू डिजिलॉकर पर क्लिक करें </b>",
        "gotodigilocker" : "डिजिलॉकर पर वापस जाएं",
        "manualflowproceed" : "मैन्युअल सत्यापन के साथ आगे बढ़ें",
        "default_fileSize" : "अधिकतम अनुमत फ़ाइल का आकार 2MB है।",
        "default_fileSize3" : "अधिकतम अनुमत फ़ाइल का आकार 5MB है।",
    }
]

export default data;
